import colors from 'theme/colors';

export const teamColors = [
  colors.taxes[600], // Purple - for teams
  colors.revenues[600], // Green - for teams
  colors.bank[600], // Blue - for teams
  colors.expenses[600], // Pink - for teams
  colors.primary[600], // Gray - for edge cases only
];

/**
 * Get a team color by adding up all characters in the ID
 * - Real teams get colorful colors (Purple, Green, Blue, Pink)
 * - Gray is reserved only for edge cases (missing ID, errors)
 * - Same ID = same color every time
 */
export const getTeamColor = (teamId: string | number): string => {
  if (!teamId) {
    return teamColors[teamColors.length - 1]; // Default color if no ID provided
  }

  // Convert to string and just add up all the character numbers
  const idString = String(teamId);
  let sum = 0;

  for (let i = 0; i < idString.length; i++) {
    sum += idString.charCodeAt(i);
  }

  // Pick a color based on the sum, but only use colorful colors (not gray)
  // Gray is reserved for edge cases only
  const colorfulColorsCount = teamColors.length - 1; // Exclude the last color (gray)
  const colorIndex = sum % colorfulColorsCount;
  return teamColors[colorIndex];
};
